<div class="compliance-tab">
  <!-- Left Column: Compliance Details -->
  <div class="col-md-6">
    <div class="form-group">
      <label class="col-md-3 control-label">Do Not Dispatch</label>
      <div class="col-md-3 inputSpace">
        <p-checkbox
          [(ngModel)]="driver.doNotDispatch"
          (ngModelChange)="onFieldChange()"
          binary="true"
          disabled="true"
          ariaLabel="Do Not Dispatch"
        ></p-checkbox>
      </div>
      <label class="col-md-3 control-label">Out of Compliance</label>
      <div class="col-md-3 inputSpace">
        <p-checkbox
          [(ngModel)]="driver.outOfCompliance"
          (ngModelChange)="onFieldChange()"
          binary="true"
          disabled="true"
          ariaLabel="Out of Compliance"
        ></p-checkbox>
      </div>
    </div>

    <hr />

    <h5>Product Qualifications</h5>
    <div *ngIf="productQualifications.length > 0" class="product-qualifications-grid">
      <div
        *ngFor="let qual of productQualifications; let i = index; trackBy: trackByProductId"
        class="product-qual-item"
      >
        <span class="product-label">{{ qual.productQualificationName }}</span>
        <div class="qualification-selector">
          <button
            type="button"
            class="qual-badge"
            [ngClass]="{
              'qual-yes': qual.qualification === 'Yes',
              'qual-no': qual.qualification === 'No',
              'qual-pre': qual.qualification === 'Prequalified',
              disabled: !isEditMode,
            }"
            (click)="false && cycleQualification(qual)"
            disabled="true"
            [attr.aria-label]="qual.productQualificationName + ' qualification: ' + qual.qualification"
          >
            <i
              class="fa"
              [ngClass]="{
                'fa-check': qual.qualification === 'Yes',
                'fa-times': qual.qualification === 'No',
                'fa-clock-o': qual.qualification === 'Prequalified',
              }"
            ></i>
            {{ qual.qualification }}
          </button>
        </div>
      </div>
    </div>

    <hr />

    <h5>Customer-Specific Training</h5>
    <div *ngIf="customerTraining.length > 0">
      <div
        *ngFor="let training of customerTraining; let i = index; trackBy: trackByIndex"
        style="margin-bottom: 10px"
      >
        <div style="display: flex; gap: 10px; align-items: center">
          <p-autoComplete
            [(ngModel)]="customerTraining[i].trainingName"
            [suggestions]="filteredTrainingNames"
            (completeMethod)="filterTrainingNames($event)"
            (onSelect)="onCustomerTrainingChange()"
            (onBlur)="onCustomerTrainingChange()"
            [disabled]="!isEditMode"
            [dropdown]="true"
            [forceSelection]="false"
            placeholder="Enter or select training"
            ariaLabel="Customer Training Name"
            styleClass="training-autocomplete"
            [style]="{ flex: '1' }"
            [inputStyle]="{ width: '100%' }"
          ></p-autoComplete>
          <select
            class="form-control"
            [name]="'trainingQual' + i"
            [(ngModel)]="customerTraining[i].qualification"
            (ngModelChange)="onCustomerTrainingChange()"
            [disabled]="!isEditMode"
            style="flex: 1"
            aria-label="Training qualification status"
          >
            <option value="">--Select--</option>
            <option *ngFor="let qual of qualificationOptions" [value]="qual">
              {{ qual }}
            </option>
          </select>
          <button
            *ngIf="isEditMode"
            class="button-form-control"
            (click)="removeCustomerTraining(i)"
            aria-label="Remove customer training"
          >
            -
          </button>
        </div>
      </div>
    </div>
    <button
      *ngIf="isEditMode"
      class="button-form-control"
      (click)="addCustomerTraining()"
      style="margin-top: 5px"
      aria-label="Add customer training"
    >
      +
    </button>
  </div>

  <!-- Right Column: Expiration Dates -->
  <div class="col-md-6">
    <p-table
      [value]="certifications"
      [paginator]="false"
      responsiveLayout="scroll"
      styleClass="p-datatable-sm"
    >
      <ng-template pTemplate="body" let-cert let-rowIndex="rowIndex">
        <tr *ngIf="rowIndex === 0">
          <td>License State</td>
          <td>{{ driver.licenseState || "N/A" }}</td>
        </tr>
        <tr [ngClass]="getExpirationClass(cert.date)">
          <td>
            {{ cert.label }}
            <span *ngIf="getExpirationText(cert.date)" class="expiration-badge">
              {{ getExpirationText(cert.date) }}
            </span>
          </td>
          <td>
            <span *ngIf="!isEditMode || cert.field !== 'physicalExamExpirationDate'">
              {{ cert.date | date: "MM/dd/yyyy" }}
            </span>
            <input
              *ngIf="isEditMode && cert.field === 'physicalExamExpirationDate'"
              type="text"
              class="form-control"
              [inputMask]="dateInputMask"
              placeholder="mm/dd/yyyy"
              [(ngModel)]="cert.date"
              (ngModelChange)="onCertificationDateChange(cert)"
              aria-label="Physical exam expiration date"
            />
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</div>
